import * as React from 'react';
import { Progress } from 'reactstrap';

import { GetSize, ToNumber } from '../../lib/utils';

import './File.scss';

class CustomFile extends React.Component<File.IProps, File.IState> {
  static defaultProps = { renderProgress: true };

  renderProgressBar = () => {
    if (this.props.isReady) {
      return null;
    } else if (this.props.renderProgressBar) return this.props.renderProgressBar;

    return (
      <Progress
        className="mt-2 custom-progress-bar"
        color={this.props.progressColor || 'eon-red'}
        value={ToNumber(this.props.progressValue)}
      />
    );
  };

  renderProgress = () => {
    if (!this.props.renderProgress || this.props.isReady) {
      return null;
    }

    return <p
      className="eon-title eon-middle-grey text-nowrap my-auto ml-2 h-100">{ToNumber(this.props.progressValue)}%</p>;
  };

  renderProgressMessage = () => {
    if (!this.props.progressMessage) {
      return null;
    }

    return <p className="eon-title eon-middle-grey text-nowrap mr-auto">{this.props.progressMessage}</p>;
  };

  renderExpireDate = () => {
    if (!this._showExpireDate()) {
      return null;
    }

    return this.props.expireDate;
  };

  renderProgressSubMessage = () => {
    if (this.props.progressSubMessage) {
      return null;
    }

    return this.props.progressSubMessage;
  };

  renderDownloadButton = () => {
    if (!this.props.isReady || !this.props.downloadButton) {
      return null;
    }

    return this.props.downloadButton;
  };

  renderDeleteButton = () => {
    if (!this.props.isReady || !this.props.deleteButton) {
      return null;
    }

    return this.props.deleteButton;
  };

  renderCancelButton = () => {
    if (this.props.isReady || !this.props.cancelButton) {
      return null;
    }

    return this.props.cancelButton;
  };

  render() {
    const textClass = this.props.textTruncate ? 'text-truncate' : 'text-nowrap';
    return (
      <div className={`d-flex ${this.props.containerClass || ''}`}>
        <span className="eon-icon csv-icon disabled my-auto" />
        <div className="my-auto custom-file-progress-width">
          <div className="d-flex align-items-center">
            <p
              className={`eon-title eon-middle-grey strong ml-0 mr-1 ${textClass}`}
              data-toggle="tooltip"
              title={this.props.fileName as string}
            >
              {this.props.fileName}
            </p>
          </div>
          {this.renderProgressBar()}
          <div className="d-flex mt-2">
            {this.renderProgressMessage()}
            <p
              className={`eon-title eon-middle-grey ${textClass} ${this._showExpireDate() ? 'mr-auto' : ''}`}
              data-toggle="tooltip"
              title={this._getFileSize() as string}
            >
              {this._getFileSize()}
            </p>
            {this.renderExpireDate()}
          </div>
          {this.renderProgressSubMessage()}
        </div>
        {this.renderProgress()}

        {this.renderDownloadButton()}
        {this.renderDeleteButton()}
        {this.renderCancelButton()}
      </div>
    );
  }

  _showExpireDate = () => this.props.isReady && this.props.expireDate;

  _getFileSize() {
    if (this.props.replaceSize) {
      return this.props.replaceSize;
    }

    return GetSize({ size: this.props.fileSize } as File);
  }
}

export default CustomFile;
